const formatter = (value = '') => {
  value = value || ''; // prevent null to happen

  if (typeof value !== 'string') {
    value = value.toString();
  }

  return value.replace(/[^\d]/g, ''); // remove all non numbers
};

const unformatter = formatter;

const type = 'number';

export { formatter, unformatter, type };
